import { createAction, props } from '@ngrx/store';
import { ClientInfo } from 'app/core/services/benutzerprofil/models/clientInfo';
import { FavoriteMerkmal } from '@models/dossier/dossier-models';
import { BenutzerProfilFavorit, ObjektTyp } from 'app/core/services/api-client';

// User Profile Loading Actions
export const userProfileRequest = createAction(
  '[UserProfile] Start loading user profile'
);

export const userProfileResponse = createAction(
  '[UserProfile] Load user profile Success',
  props<{
    fachlektorMerkmale: Set<number>;
    lieferantenMerkmale: Set<number>;
    clientInfo: ClientInfo;
    favouriteMerkmale: FavoriteMerkmal[];
  }>()
);

export const userProfileError = createAction(
  '[UserProfile] Load user profile Error',
  props<{ error: string }>()
);

// Favorite Merkmale Actions
export const addFavoriteMerkmalSuccess = createAction(
  '[UserProfile] Add to favorite merkmale (Success)',
  props<{ favoriteMerkmal: FavoriteMerkmal }>()
);

export const setFavoriteMerkmale = createAction(
  '[UserProfile] Set favorite merkmale',
  props<{ newFavoriteMerkmale: FavoriteMerkmal[] }>()
);

// Client Info Actions
export const loadClientInfoSuccess = createAction(
  '[UserProfile] Load client info (Success)'
);

export const loadClientInfoError = createAction(
  '[UserProfile] Load client info (Error)'
);

export const saveClientInfoSuccess = createAction(
  '[UserProfile] Save client info (Success)'
);

export const saveClientInfoError = createAction(
  '[UserProfile] Save client info (Error)'
);

// Load Favoriten
export const loadFavoriten = createAction(
  '[Favoriten] Load Favoriten'
);

export const loadFavoritenSuccess = createAction(
  '[Favoriten] Load Favoriten Success',
  props<{ favoriten: BenutzerProfilFavorit[] }>()
);

export const loadFavoritenFailure = createAction(
  '[Favoriten] Load Favoriten Failure',
  props<{ error: string }>()
);

// Add Favorit
export const addFavorit = createAction(
  '[Favoriten] Add Favorit',
  props<{ objektTyp: ObjektTyp; objektId: number }>()
);

export const addFavoritSuccess = createAction(
  '[Favoriten] Add Favorit Success',
  props<{ favorit: BenutzerProfilFavorit }>()
);

export const addFavoritFailure = createAction(
  '[Favoriten] Add Favorit Failure',
  props<{ error: string }>()
);

// Remove Favorit
export const removeFavorit = createAction(
  '[Favoriten] Remove Favorit',
  props<{ objektTyp: ObjektTyp; objektId: number }>()
);

export const removeFavoritSuccess = createAction(
  '[Favoriten] Remove Favorit Success',
  props<{ objektTyp: ObjektTyp; objektId: number }>()
);

export const removeFavoritFailure = createAction(
  '[Favoriten] Remove Favorit Failure',
  props<{ error: string }>()
);

// Check Favorit
export const checkFavorit = createAction(
  '[Favoriten] Check Favorit',
  props<{ objektTyp: ObjektTyp; objektId: number }>()
);

export const checkFavoritSuccess = createAction(
  '[Favoriten] Check Favorit Success',
  props<{ objektTyp: ObjektTyp; objektId: number; favorit: BenutzerProfilFavorit | null }>()
);

export const checkFavoritFailure = createAction(
  '[Favoriten] Check Favorit Failure',
  props<{ error: string }>()
);
